module.exports = __webpack_public_path__ + "img/partner_logo6.01b2e470.png";